import BundleVersionListRow from './BundleVersionListRow';

export default BundleVersionListRow;
